import { __rest } from "tslib";
import * as React from 'react';
import { useContext } from 'react';
import cn from 'classnames';
import { useTheme } from '../../../theme';
import { OrderStatus as OrderStatusEnum } from '@websky/graphql';
import OrderStatusText from './OrderStatusText/OrderStatusText';
import { OrderCardContext } from '../OrderCard';
import CommonItem from '../CommonItem/CommonItem';
const OrderStatus = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    const { OrderStatus: css } = useTheme('OrderCard');
    const { order, type } = useContext(OrderCardContext);
    const isBookedOrConfirmed = order.status === OrderStatusEnum.Booked || order.status === OrderStatusEnum.Confirmed;
    const isCancelled = order.status === OrderStatusEnum.Cancelled || order.status === OrderStatusEnum.Problematic;
    const getIcon = () => {
        if (isBookedOrConfirmed) {
            return 'Info/Check';
        }
        if (isCancelled) {
            return 'Info/Not included';
        }
        return null;
    };
    return (React.createElement(CommonItem, Object.assign({ icon: getIcon(), type: type, iconClassName: css.icon, text: React.createElement(OrderStatusText, { status: order.status }), buttons: null, className: cn(css.root, className, {
            [css.confirmed]: isBookedOrConfirmed,
            [css.canceled]: isCancelled,
            [css.type_review]: type === 'review',
            [css.type_account]: type === 'account'
        }) }, props)));
};
export default OrderStatus;
